module.exports = __webpack_public_path__ + "img/bookmark-x-fill.d87b03a7.svg";